import { styled } from 'styled-components';

export const Container = styled.button`
  width: 100%;

  hr {
    margin: 1rem 0 0;
  }

  @media (min-width: 991px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;

    hr {
      display: none;
    }
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  gap: 1rem;
`;

export const FooterCard = styled.div`
  display: flex;
  align-content: center;
  gap: 1rem;

  @media (max-width: 991px) {
    padding-top: 0.7rem;
    width: 100%;
    :first-child {
      flex: 1;
    }
  }
`;

export const InfoUser = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.1rem;
`;
